import { List } from "immutable";
import { ADVANCED_FILL_DEFAULT_VALUES } from "@/constants/AdvancedFillModePresetConstants";

/**
 * Checks if backdropFilter exists and has data
 * @param {any} backdropFilter - The backdropFilter value (Immutable List from element props)
 * @returns {boolean} True if backdropFilter is a non-empty List
 */
export const hasBackdropFilter = (backdropFilter) =>
  List.isList(backdropFilter) && backdropFilter.size > 0;

/**
 * Default for a known filter name; undefined for unknown names.
 * @param {string} filterName
 * @returns {number|undefined}
 */
const getDefaultFilterValue = (filterName) =>
  filterName in ADVANCED_FILL_DEFAULT_VALUES ? ADVANCED_FILL_DEFAULT_VALUES[filterName] : null;

/**
 * Retrieves the value of a specific filter function from the backdrop filter array.
 *
 * @param {import("immutable").List} backdropFilter - Advanced Fill array of filter functions
 * @param {string} filterName - Property name to extract (e.g. "blur", "brightness", "contrast")
 * @returns {number}
 */
export const getAdvanceFilterValueFromArray = (backdropFilter, filterName) => {
  const defaultValue = getDefaultFilterValue(filterName);
  if (!backdropFilter) return defaultValue;

  if (List.isList(backdropFilter)) {
    return backdropFilter
      .find((item) => item?.has?.(filterName))
      ?.get(filterName) ?? defaultValue;
  }

  return defaultValue;
};
